import { render, staticRenderFns } from "./GrantsConstraintsPlanBtns.vue?vue&type=template&id=794517ae&"
import script from "./GrantsConstraintsPlanBtns.vue?vue&type=script&lang=js&"
export * from "./GrantsConstraintsPlanBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports